import {
  InitiatePaymentResponse,
  SubscriptionsPageData
} from "@/src/sb/business-layer/types"
import { GetStaticPropsResult } from "next"
import React from "react"

// Type definition used in PayWithPaystack Component
export type verifySuccessfulPaymentArgs = {
  reference: string
  provider: InitiatePaymentResponse["provider"]
}

const Subscriptions = () => {
  return <section>{/* This page has been decommissioned */}</section>
}

export async function getStaticProps(): Promise<
  GetStaticPropsResult<SubscriptionsPageData>
> {
  return {
    notFound: true
  }
}

export default Subscriptions
